(function($){

	var isHome = document.body.classList.contains('home'),
		isPage = document.body.classList.contains('page'),
		isMobile = 'ontouchstart' in window,
		isSafari = /apple/i.test(navigator.vendor),
//		hasLazy = 'loading' in HTMLImageElement.prototype,
		
		announcementContainer = $('.announcement__container'),
		announcements = announcementContainer.find('.announcement'),
		
		megaSlider = $('.venue-mega-slider .megaSlider'),
		sixMaps = $('.sixsquare-map'),
		sliders = $('.slickSlider'),
		touchhover = $('.touchhover'),
		scrollUp = $('.scroll-up'),
		scrollDown = $('.scroll-down'),
		footerBG , //= $('.footer-bg')[0],
		footerBGtop = 0,
		footerSlider = $('.footer-gallery .footerSlider'),
		
		header = $('header.header').first(),
		headerHero = $('.header-hero').first(),
		contentContainer = $('.off-canvas-content > .content'),
		headerTitle = $('.header-hero .title__container .title__innerContainer'),
		articleHeader = $('main.main > article header.article-header'),
		articleTitleContainer = articleHeader.children('.title__container'),
		articleTitleContainerInner = articleTitleContainer.children('.title__innerContainer')[0],
		titleContainerHeight = 0,
		titleContainerTop = 0,
		titleBottom = 0,

		scrollAnimates,
		scrollAnimatesList = [],
		
		slickSliderGrabY = 0,
		slickSliderGrabX = 0,
		slickSliderGrabInhibit = false,
		
		raf_latestKnownScrollY = 0,
		raf_ticking = false,
		
		eMega1 =
		eMega2 =
		megaSlides =
		megaSliderTimeout =
		megaVideoTries =
		megaPauseState =
		offCanvasMegaPauseState = null,
		megaPause =
		miniVenueSwiper = function() {},
		contentTop = 0,
		windowWidth = 0,
		windowHeight = 0,
		headerHeight = 0;

	// pick random slide if class set on slider: randomInitialSlide
	var rSliders = document.getElementsByClassName('randomInitialSlide');
	if ( rSliders.length ) {
		[...rSliders].forEach( s => {
			c = s.children;
			if ( c.length ) {
				c[Math.round( Math.random() * ( c.length - 1 ) )].classList.add('initialSlide');		
			}
		} );
	}

	// Set Page Measurements
	var setMeasurements = function () {
		// Set default VH unit for mobile (Safari toolbar full height fix)
		if ( window.innerWidth != windowWidth ) {
			windowWidth = window.innerWidth;
			
			var vh = window.innerHeight * 0.01; // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
			document.documentElement.style.setProperty('--vh', `${vh}px`);
		}
		
		windowHeight = window.innerHeight;
//		raf_latestKnownScrollY = window.scrollY;
				
		if ( headerHero.length ) {
			contentTop = headerHero.outerHeight();
		} else {
			contentTop = header.outerHeight();
		}
				
		if ( header.length ) {
			headerHeight = header.outerHeight();
		} else {
			headerHeight = 20;
		}
		
		if ( footerBG ) footerBGtop = footerBG.offsetTop;
		
		if ( headerTitle.length ) titleBottom = parseFloat(headerTitle.css('top').replace("px","")) + headerTitle.outerHeight();
		if ( articleTitleContainer.length ) {
			titleContainerHeight = articleTitleContainer.height();
			titleContainerTop = articleTitleContainer.offset().top;
		}		
		

	};
	var IO = window.IntersectionObserver || null;
	// Scroll items
	var setScrollItems = function () {	
		if ( scrollAnimatesList.length && !scrollAnimates ) {
			scrollAnimates = [];

			$.each(scrollAnimatesList,function(i,v) {
				var els = $(v);
				if ( els.length ) {
					els = $.map( els.toArray(), function( n, i ){
						n.dataset.saIndex = i;
						return {el: n, top: null, height: null, visible: null, class: [...n.classList]}
					});
					scrollAnimates = $.merge(scrollAnimates,els);
				}
			});
			
			$.each( scrollAnimates,function(i,t){ ioScrollItem.observe(t.el); });
		}
	};
	//
	let ioScrollItem = new IO( function(entries) {				//								console.log(`IO called and ended `); console.log(entries);
		$.each(entries,function(ii,entry) {
			var index = null;
/*
var startTime = window.performance.now()
			$.each(scrollAnimates,function(i,v){
				if ( v.el == entry.target ) index = i;
			});
var endTime = window.performance.now()
console.log(`each scrollAnimates took ${endTime - startTime} milliseconds`);
startTime = window.performance.now()
			 index = entry.target.dataset.saIndex;
endTime = window.performance.now()
console.log(`dataset took ${endTime - startTime} milliseconds (${index})`);
*/
			index = entry.target.dataset.saIndex;
			if ( index > -1 ) {
				scrollAnimates[index].visible = entry.isIntersecting;
				scrollAnimates[index].top = entry.boundingClientRect.top + raf_latestKnownScrollY;
				scrollAnimates[index].height = entry.boundingClientRect.height;
			}
		});
	}, {threshold: [0.00,0.01]});

	// Intersection Observer	
	var observer = new IO(function(entries) {
		for(let i=0; i < entries.length; i++) {
			// entries[i]['intersectionRatio']
			// entries[i]['isIntersecting']
			// entries[i]['target']
			if ( entries[i]['isIntersecting'] === true ) {
				entries[i]['target'].classList.remove('pre-init');
			}
		}
	}, { threshold: [0.8] }); 					// Example use: timelineContainer.children('.date').each(function() { observer.observe(this); } );
	
	if ( footerSlider.length ) {
		// remove lazy loading when visible
		var footerSliderObserver = new IO(function(entries) {
			for(let i=0; i < entries.length; i++) {
				// entries[i]['intersectionRatio']
				// entries[i]['isIntersecting']
				// entries[i]['target']
				if ( entries[i]['isIntersecting'] === true ) {
					$(entries[i]['target']).find('.slide img').removeAttr('loading');
					footerSliderObserver.unobserve(entries[i]['target']);
				}
			}
		}, { threshold: [0.1] });
		footerSliderObserver.observe(footerSlider[0]);
	}		
$(document).ready(function() {
	setScrollItems();
	setMeasurements();
		
	// SVG load
	$('img.svg-load').each( function() { 
		var $img = $(this);
		var imgID = $img.attr('id');
		var imgClass = $img.attr('class');
		var imgURL = $img.attr('src');
		$.get({
			url: imgURL,
			cache: true,
			dataType: 'xml',
			success: function (data) {
				// Get the SVG tag, ignore the rest
				var $svg = $(data).find('svg');
				// Add replaced image's ID to the new SVG
				if(typeof imgID !== 'undefined') {
					$svg = $svg.attr('id', imgID);
				}
				// Add replaced image's classes to the new SVG
				if(typeof imgClass !== 'undefined') {
					$svg = $svg.attr('class', imgClass);
				}
				// Remove any invalid XML tags as per http://validator.w3.org
				$svg = $svg.removeAttr('xmlns:a');
				// Replace image with new SVG
				$img.replaceWith($svg);
			}
		});
	});
	
	// Mobile
	if ( isMobile ) document.body.classList.add('is-mobile');
	if ( isSafari ) document.body.classList.add('is-safari');
	
	// Parallax
	//	var parallax = new Rellax('.ll',{speed:1.5});
	
	// Lazy Load Images
	const limg = $('img.lazy');
	if ( limg.length ) {		
		const limg_intersection = new IO(function(entries) {
			$.each(entries,function(ii,entry) {
				if ( entry.isIntersecting === true ) {
					entry.target.setAttribute('src', entry.target.dataset.src);
					limg_intersection.unobserve(entry.target);
				}
			});
		}, { threshold: [0.35] });
		
		limg
		.on('load', function() { this.classList.add('loaded'); })
		.each(function() { limg_intersection.observe(this); });
	}

	// Six maps
	if ( sixMaps.length ) {
		const sm_intersection = new IO(function(entries) {
			$.each(entries,function(ii,entry) {
				if ( entry.isIntersecting === true ) {
					sixSquareMapFeatures( $(entry.target) );
					sm_intersection.unobserve( entry.target );
				}
			});
		}, { threshold: [0.55] });
		
		sixMaps.each(function() { sm_intersection.observe(this); });
	}

	// Announcements
	if ( announcements.length ) {
		if ( sessionStorage.announcementsClosed && sessionStorage.announcementsClosed.length ) {
			
			var ss = sessionStorage.announcementsClosed.split(','),
				reset = false;
			
			announcements =  $($.grep(announcements,function(el,i) {
				
				if ( ss.indexOf( el.dataset.aid ) > -1 ) {
					$(el).closest('.swiper-slide').remove();
					return false;
				}
				
				return true;
				
			}));
			
		}

		if ( announcements.length > 1 ) {
			new Swiper ( announcementContainer[0],  {
							direction: 'horizontal',
							loop: true,
							allowTouchMove: false,
							speed: 600,
							autoplay: {
								delay: 5000
							}
						} );
		}
		announcementContainer.on("closed.zf",function(e){
			var announcement = $(e.target),
				aid = announcement.data('aid');

			announcements =  $($.grep(announcements,function(el,i) {
				if ( el.dataset.aid == aid ) {
					$('.announcement[data-aid="' + aid + '"]').closest('.swiper-slide').remove();
					return false;
				}
				return true;
			}));
			
			if ( announcements.length > 0 ) announcementContainer[0].swiper.update();
			if ( announcements.length == 1 ) {
				announcementContainer[0].swiper.disable();
			}

		
			if ( aid.length ) {
				var ss = [];
				if ( sessionStorage.announcementsClosed && sessionStorage.announcementsClosed.length ) ss = sessionStorage.announcementsClosed.split(',');
				if ( !ss.indexOf(aid) > -1 ) {
					ss.push(aid);
					sessionStorage.announcementsClosed = ss;
				}
			
			}
		});
		
		// fade in
		announcementContainer.addClass('ready');
		
/*		//Orbit pause on click fix
		announcementContainer.find('.orbit-slide').on('click.zf.orbit', function() { 
			var orbit = $(this).closest('.orbit'); 
			setTimeout( function() {
				if ( orbit.data('paused') == true )
					orbit.closest('.orbit').data('clickedOn',false).foundation('geoSync');
			}, 100);
		});
*/
	}

	
	
	// Mega Venue Slider Home Page Header Hero
	if ( megaSlider.length ) {
		
		megaSlides = megaSlider.children();
		eMega1 = new CustomEvent('megaSlideInactive');
		eMega2 = new CustomEvent('megaSlideActive');
		
		var megaVideos = megaSlides.find('video'),
			megaSliderNav = $('.venue-mega-slider-nav'),
			megaNavSwiper = false,
			slideMega = function(){},
			slideMegaTimeout = function() {
							if ( megaNavSwiper ) megaNavSwiper.slideNext();
							else slideMega( 'next' );
							megaSliderTimeout = null;
						};
		
		megaPause = function(state) {
			var currentSlider = megaSlides.filter('.active');
			
			if ( state == 'play' && megaPauseState ) {													console.log(`%% megaPause1 %% play %% ${megaPauseState}`);
				switch ( megaPauseState ) {
					case 1: megaSliderTimeout = setTimeout( slideMegaTimeout, 3000 );
						break;
					case 2: slickVideoSlideInit(currentSlider[0]);
						break;
					case 3: currentSlider.slick('slickPlay');
						break;
				}
				megaPauseState = false;
			} else if ( state != 'play' && !megaPauseState ) {
				if ( megaSliderTimeout ) {
					// timeout set on current slide
					clearTimeout(megaSliderTimeout);
					megaSliderTimeout = null;
					megaPauseState = 1;
				}
				else if ( currentSlider.find('.slick-current').hasClass('video') ) {
					// current slide has video
					slickPauser(currentSlider[0]);
					megaPauseState = 2;
				}
				else {
					// multi-slide slider
					slickPauser(currentSlider[0]);
					megaPauseState = 3;
				}																		console.log(`%% megaPause2 %% pause %% ${megaPauseState}`);
			}																	else	console.log(`%% megaPause3 %% ${state} %% ${megaPauseState}`);
		};

		
		// Mega Slider post transition/slide
		megaSlider.on('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd',function(e){
			if ( e.target != this ){ return; }
			this.classList.remove('sliding','presliding');
			this.style.transform = '';
		});
		// Mega Slider can slide to any slide forward or backward
		// slideMega ( index to slide [1...] [use negative to slide backwards])
		// assumtions: show one slide at a time, full width of 100vw 
		slideMega = function (n) {
			var curSlide = megaSlides.filter('.active'),
				curIndex = curSlide.index();

			if ( n == 'next' ) {
				if ( curIndex >= ( megaSlides.length - 1 ) ) n = 1;
				else n = curIndex + 2;
			}
			if ( !n ) return;
			
			var	forward = n > 0,
				n = Math.abs(n) - 1,
				nOrder;
		
			if ( n == curIndex || n > ( megaSlides.length - 1 ) ) return;
		
			megaSlides.each(function(i,el){
				if ( forward ) {
					if ( i == curIndex ) el.style.order = 0;
					else if ( i < curIndex ) el.style.order = megaSlides.length - curIndex + i;
					else el.style.order = i - curIndex;
		
				} else {
					if ( i == curIndex ) el.style.order = megaSlides.length - 1;
					else if ( i < curIndex ) el.style.order = megaSlides.length - 1 - curIndex + i;
					else el.style.order = i - curIndex - 1;
		
				}
				if ( n == i ) nOrder = el.style.order * 1;
			});
		
			if ( !forward ) { megaSlider.addClass('presliding').css('transform','translate3d('+ ( megaSlides.length - 1 ) * -100 +'vw,0,0)'); console.log(`translateX ${nOrder}`)}
			
			setTimeout(function(){
				curSlide[0].dispatchEvent(eMega1);
				
				megaSlider.addClass('sliding').css('transform','translate3d('+ nOrder * -100 +'vw,0,0)');
		
				megaSlides.removeClass('active');
				megaSlides.eq(n).addClass('active')[0].dispatchEvent(eMega2);
			},100);
		
		}

		// Rolodex Nav Slider
		if ( megaSliderNav.length ) {
			var swiperslides = megaSliderNav.find('.slide');
			if ( swiperslides.length < 4 ) {
				swiperslides.clone().insertAfter(swiperslides.last());
			}
			
			megaNavSwiper = new Swiper('.venue-mega-slider-nav .swiper', {
				direction: 'vertical',
				centeredSlides: true,
				grabCursor: true,
	//			slideToClickedSlide: true,
				loop: true,
				slidesPerView: 3,
				on: {
					slideChangeTransitionStart: function (swiper) {
						var slide = $(swiper.slides[swiper.activeIndex]),
							venue = slide.data('venue');
																				
							if ( swiper.activeIndex > swiper.previousIndex ) {
								// moving forward
								slideMega( swiper.realIndex + 1 );
							} else {
								// moving backward
								slideMega( -1 * ( swiper.realIndex + 1 ) );
							}
						
					},
					touchEnd: function(s,e) { // test for dragging active, trigger cursor element to show without mouseleave
						if ( !isMobile && s.touches.diff ) {
							// update cursor element
							window.cursor.style.left = e.x + 'px';
							window.cursor.style.top = e.y + 'px';
							setTimeout(function(){
								var slideLink = $(s.slides[s.activeIndex]).children('a');
								if ( slideLink.is(':hover') ) slideLink.trigger('mouseenter');
							},100);
						}
					}
				}
			});
			
			megaSliderNav.click(function(e){
				var slide = $(e.target);
				if ( !slide.hasClass('slide') ) slide = slide.parent();
				if ( !slide.hasClass('slide') || slide.hasClass('swiper-slide-active') ) return true;
				e.preventDefault();

				if ( slide.next().hasClass('swiper-slide-active') ) megaNavSwiper.slidePrev();
				else megaNavSwiper.slideNext()
				return false;
			});
			
		}

		// Venue Slider contained within the Home Mega Slider
		$('.venue-slider').on('init reInit',function(event,slick) {
			if ( !event.target.classList.contains('venue-slider') ) return;
																					// console.log('VENUE SLIDER init'); console.log(event.target);// window.lastSlickV = slick; console.log(event);console.log(slick);
			$(this).find('video').each(function() {
				var video = $(this);
				video.off('ended');
				video.on('ended',function() {
					if ( slick.$slides.length > 1 ) {															console.log('%%% Video ended: Playing Slider');
						slick.play();
						slick.next();
					} else {																					console.log('%%% Video ended: mega swiping on');
						if ( megaNavSwiper ) megaNavSwiper.slideNext(); //slideMega('next');
						else slideMega( 'next' );
					}
				});
				video.off('play');
				video.on('play',function() {																		console.log('%%% VIDEO PLAYED');
					slick.pause();
				});
			});
		
			$(this)
			.on('megaSlideInactive', function() {
				slickPauser(this);
				if ( megaSliderTimeout ) {
					// timeout set on current slide
					clearTimeout(megaSliderTimeout);
					megaSliderTimeout = null;
				}
			})
			.on('megaSlideActive', function() {
				if ( ! slickVideoSlideInit(this) ) {
					if ( slick.$slides.length == ( slick.currentSlide + 1 ) ) {
						megaSliderTimeout = setTimeout( slideMegaTimeout, 9000 );
					}
					else if ( this.slick ) this.slick.play();
				}
			});
			
			/*
			if ( this.classList.contains('active') ) setTimeout(function(){ 		console.log( 'Playing / Initing active venue slider' );
				slick.play();
				slickVideoSlideInit(slick.$slider);
			}, 500);
			*/
		
		}).on('beforeChange', (event, slick, currentSlide, nextSlide) => { //		console.log('VENUE SLIDER BEFORE CHANGE'); window.lastSlickV = slick; console.log(event);console.log(slick);console.log(currentSlide);console.log(nextSlide);
			if ( !event.target.classList.contains('venue-slider') ) return;

			var slide = $(slick.$slides[currentSlide]);
			slide.find('video').each(function(){ this.pause(); } );
		
			if ( nextSlide == 0 ) {
				slick.pause();
				if ( megaNavSwiper ) megaNavSwiper.slideNext();
				else slideMega( 'next' );
			}

		}).on('afterChange', function(event, slick, currentSlide) { //		console.log('VENUE SLIDER AFTER CHANGE'); window.lastSlickV = slick; console.log(event);console.log(slick);console.log(currentSlide);
			if ( !event.target.classList.contains('venue-slider') ) return;

			//var slide = slick.$slides[currentSlide];
			slickVideoSlideInit(slick.$slider);		
		});
		
		if ( !megaSliderNav.length ) {
console.log('slide click enabled');
			$('.venue-slider .slide').click(function() {
console.log('slide clicked');
				if ( this.classList.contains('canplay') || ! this.classList.contains('video') ) {
					var url = $(this).closest('.venue-slider').data('url');
					if (url && url.length) window.location = url;
					else console.log('no url');
					console.log(url);
				} else console.log('no canplay?');
			});
		}
	
		function slickVideoSlideInit(slider) {
			var slider = $(slider),
				slide = slider.find('.slide.slick-current');
			if ( !slide.length && slider.find('.slide').length == 1 ) slide = slider.find('.slide');
			if ( slide.hasClass('video') ) {															console.log('SLIDE HAS VIDEO TRY PLAYING');

				v = slide.find('video');

				if ( v.length ) {																		console.log('SLIDE HAS VIDEO TRY PLAYING2');
				
					if ( null == v.attr('src') ) {
						// lazy load video
						v.attr('src', v.data('src'));
						v[0].load();
					}

					slickVideo('play',v[0]);
				
					return true;
				}
			}
		
			return false;
		}
		function slickPauser(slider) {
			if ( typeof slider.slick != 'object' ) return;
			var slider = $(slider),
				slide = slider.find('.slide.slick-current');

			if ( !slide.length && slider.find('.slide').length == 1 ) slide = slider.find('.slide');

			slider.slick('slickPause');
	
			if ( slide.hasClass('video') ) {
				var v = slide.find('video');
				if ( v.length && v[0].played.length ) {
					v[0].pause();
				}
			}
		}
		function slickVideo(action,video) {
			if ( action == 'play' ) {
				var promise = video.play();
		
				if (promise !== undefined) {
					promise.catch(error => {
						// Auto-play was prevented
						// Show a UI element to let the user manually start playback
											console.log('SLIDE HAS VIDEO FAIL ' + megaVideoTries);
						if ( megaVideoTries < 3 ) {
							megaVideoTries++;
							setTimeout(function(){
								slickVideo(action,video);
							},400);
						}
					}).then(() => {
						// Auto-play started
												console.log('SLIDE HAS VIDEO PLAYING');
						video.parentNode.classList.add('canplay');
						if ( megaPauseState ) video.pause();
						if ( !megaSliderNav.length && video.parentNode.matches(':hover') ) window.cursor.classList.add('visible','more-info');
					});
				}

			}
		}
	
	} // if megaSlider.length
	
	// Off-canvas Venue Slider
	var venueSlider = $('.venue_slides .swiper');
	miniVenueSwiper = function () {
		if ( ! venueSlider.length ) return;
		var inited = venueSlider.hasClass('swiper-initialized'),
			horizontal = venueSlider.hasClass('swiper-horizontal'),
			swiper = venueSlider[0].swiper;

		if ( Foundation.MediaQuery.atLeast('medium') ) {
			if ( inited && !horizontal ) return;
			if ( inited ) swiper.destroy();
			
			swiper = new Swiper('.venue_slides .swiper', {
				direction: 'vertical',
				centeredSlides: false,
				grabCursor: true,
				mousewheel: {thresholdDelta: 10},
				loop: true,
				loopedSlides: 6,
				slidesPerView: 'auto',
				spaceBetween: 0,
				navigation: {
				   nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
			  	},
			});
		} else {
			if ( inited && horizontal ) return;
			if ( inited ) swiper.destroy();
			
			swiper  = new Swiper('.venue_slides .swiper', {
				direction: 'horizontal',
				centeredSlides: true,
				grabCursor: true,
				loop: true,
				loopAdditionalSlides: 3,
				touchRatio: 1.2,
				slidesPerView: 1.75,
				spaceBetween: 6,
				mousewheel: false,
				cssMode: false,
				navigation: false,
				breakpoints: {
					375: {
						slidesPerView: 1.5
					}
				}
			});
		}
	};
	
	if ( venueSlider.length ) {
		miniVenueSwiper();
	}
	    
	
	// Slick Slider
	sliders.each(function() {
		var t = $(this),
			initialSlide = Math.max(0,t.children('.slide.initialSlide').index());
		
		t.on('init',function(e,slick){
			var t = $(this),
				h = t.height();
				
			if ( slick.options.centerMode ) t.addClass('centerMode');
			if ( ! t.hasClass('hero') ) t.height(h);
		
		}).on('reInit',function(e,slick) {
			var t = $(this),
				h = t.css('height','').height();
				
				if ( ! t.hasClass('hero') ) t.height(h);
				
		}).on('beforeChange', (event, slick, currentSlide, nextSlide) => {
//			var nextSlide = slick.$slides[nextSlide];

			
		}).on('afterChange', function(event, slick, currentSlide) {
//			var slide = $(event.target).find('.slick-current');
			
		}).slick({
			// Default options
/*			infinite: false,
			arrows: false,
			swipeToSlide: true,
			slidesToShow: 3,
			variableWidth: true,
			*/
			initialSlide: initialSlide,
			centerPadding: '20%',
			autoplay: true,
			autoplaySpeed: 5000,
			speed: 600,
			responsive: [
				{ 	breakpoint: 1680,
					settings: {
						centerPadding: '15%'
					}
				}
			]
		});
	});

	
	// Easy Grid Slider
	var gS = $('.gridSlider').data('gridSliderPos',0); 
	$('<button class="gS_prev"></button><button class="gS_next"></button>').appendTo(gS).click(function(){
		var t = $(this);
		var gS = t.parent('.gridSlider');
		var cur = gS.data('gridSliderPos');
		var move = ( t.hasClass('gS_prev') ? -1 : 1 );
		var slides = gS.children('.cell');
		var maxed = ( ( gS.width() - 1 ) > ( slides.last().position().left ) );
		if ( ( ! maxed || move < 0 ) && (cur + move) >= 0 ) {
			gS.removeClass('gs-' + cur);
			gS.addClass('gs-' + (cur + move) ).data('gridSliderPos', cur + move);
		}
	});
		
	// Scroll Down widget
	if ( scrollDown.length && contentTop ) {
		scrollDown.click(function(){
			var t = (contentTop/400) * 800;
			$('html, body').animate({ scrollTop: contentTop }, t, 'easeInQuad');
		});
		/*
		window.scroll({
		  top: contentTop,
		  behavior: 'smooth'
		});
		*/
	}
	
	// Scroll Up widget
	if ( scrollUp.length && contentTop ) {
		scrollUp.on("click", function(){
			var t = Math.min( 1800, Math.round((scrollUp.offset().top/400) * 200) );
			$('html, body').animate({ scrollTop: 0 }, t, 'easeInQuad');
		});
		/*
		window.scroll({
		  top: 0,
		  behavior: 'smooth'
		});
		*/
	}
		
	// Resize with throttle
	$(window).on('resize', Foundation.util.throttle( function (event) {
	
		sliders.each(function() {
			var t = $(this),
				h = t.css('height','').height();
				if ( ! t.hasClass('hero') ) t.height(h);
	
		});
	
		setMeasurements();
		
			
	}, 300) ).resize();
	
	if ( headerHero.length ) {
		// Watch header hero intersection
		const header_hero_io = new IO(function(entries) {
			$.each(entries,function(ii,entry) {
			
				if ( entry.intersectionRatio == 0 ) {
					if ( scrollUp.length ) scrollUp.addClass('visible');
				} else {
					if ( scrollUp.length ) scrollUp.removeClass('visible');
				}
				if ( entry.intersectionRatio < 0.5 ) {
					megaPause();
				} else megaPause('play');
				if ( entry.intersectionRatio < 0.2 ) {
					header.addClass('scrolled').removeClass('unscrolled');
				}
				else {
					if ( header.hasClass('scrolled') ) header.addClass('unscrolled');
					header.removeClass('scrolled');
				}
			});
		}, { threshold: [0.0,0.1,0.2,0.5] });
		header_hero_io.observe(headerHero[0]);
	}
	
	// Scrolling with throttle
	$(window).on('scroll', Foundation.util.throttle( function (event) {
	
		var wTop = $(this).scrollTop();
			
//		sixSquareMapCheck();
		
		if ( !document.body.classList.contains('locked') ) {
			/* 
			if ( contentTop ) {
				if ( wTop >= ( contentTop - headerHeight ) ) {
					header.addClass('scrolled').removeClass('unscrolled');
				} else {
					if ( header.hasClass('scrolled') ) header.addClass('unscrolled');
					header.removeClass('scrolled');
				}
			}
				
			if ( scrollDown.length ) {
				if ( scrollDown.offset().top > contentTop ) {
					scrollDown.addClass('collapse');
				} else {
					scrollDown.removeClass('collapse');
				}
			}
			*/
		}
			
	}, 300) );
	
	// Scroll linked effects updater via requestAnimationFrame
	// can be updated to be an array or such of objects
	function raf_update() {
		raf_ticking = false;
		
		var windowBottom = raf_latestKnownScrollY + windowHeight;

		if (articleTitleContainer.length && !isHome ) {
			var wAnchor = raf_latestKnownScrollY + titleBottom, // (window.innerHeight * short),
				tcBottom = titleContainerTop + titleContainerHeight; //articleTitleContainer.innerHeight();

			if ( wAnchor > tcBottom ) {
				articleTitleContainerInner.classList.add('stuck')
				//articleTitleContainer.children('.title__innerContainer').addClass('stuck');
			}
			else {
				articleTitleContainerInner.classList.remove('stuck')
//				articleTitleContainer.children('.title__innerContainer').removeClass('stuck');
			}
			
			// Article Header Height animates distance between hero and copy
			if ( raf_latestKnownScrollY >= titleContainerHeight ) {
				articleHeader.css('height','');
			} else {
				articleHeader.css('height',raf_latestKnownScrollY + 'px');
			}
			
		}

		
		// Scroll Animates
/*		scrollAnimates.each(function(){
			var t = this,
				percent = Math.max( 0, Math.min( 1, (((raf_latestKnownScrollY - t.offsetTop + windowHeight ) / windowHeight) - 0.2 ) * 1.4 ) );

			if ( t.classList.contains('wp-block-media-text') ) {
				$.each(t.children, function(i,c) {
					if ( c.classList.contains('wp-block-media-text__content') ) c.style.opacity = percent;
					else if ( c.classList.contains('wp-block-media-text__media') && t.classList.contains('has-media-on-the-right') ) c.style.transform = "translate("+(100 - percent*100)+"%,"+(100 - percent*100)+"%)";
					else if ( c.classList.contains('wp-block-media-text__media') )  c.style.transform = "translate("+(-100 - percent*-100)+"%,"+(100 - percent*100)+"%)";
					
				});
			}
		}); */
		
		$.each(scrollAnimates, function(i,scrollItem) {
			if ( scrollItem.visible !== false ) {
				var heightPercentageInverse = 1 - ( Math.min(1,(scrollItem.height / windowHeight )) ),
					heightMultiplier = ( heightPercentageInverse > 0 ? heightPercentageInverse + 1 : 1 ),
					percent = Math.max( 0, Math.min( 1, (((raf_latestKnownScrollY - scrollItem.top + windowHeight ) / windowHeight) - 0.2 ) * 1.4 * heightMultiplier ) );
				if ( scrollItem.class.indexOf('wp-block-media-text') > -1 ) {
					$.each(scrollItem.el.children, function(i,c) {
						if ( c.classList.contains('wp-block-media-text__content') ) c.style.opacity = percent;
						else if ( c.classList.contains('wp-block-media-text__media') && scrollItem.el.classList.contains('has-media-on-the-right') ) c.style.transform = "translate("+(100 - percent*100)+"%,"+(100 - percent*100)+"%)";
						else if ( c.classList.contains('wp-block-media-text__media') )  c.style.transform = "translate("+(-100 - percent*-100)+"%,"+(100 - percent*100)+"%)";
						
					});
				}
				else if ( scrollItem.class.indexOf('package') > -1 || scrollItem.class.indexOf('event') > -1 || scrollItem.class.indexOf('room') > -1 ) {
					$.each(scrollItem.el.children, function(i,c) {
						if ( c.classList.contains('text') ) c.style.opacity = percent;
						if ( c.classList.contains('image') ) {
							if ( scrollItem.class.indexOf('even') == -1 ) c.style.transform = "translate("+(100 - percent*100)+"%,"+(100 - percent*100)+"%)";
							else  c.style.transform = "translate("+(-100 - percent*-100)+"%,"+(100 - percent*100)+"%)";
						}
					});
				}
				
			}
			// first run, then exclude -- not working, IO goes first
			if ( scrollItem.visible === null ) { scrollItem.visible = false; console.log('nullVisible#####'); }
			
		});

		// Footer BG
		if ( footerBGtop && footerBGtop <= windowBottom ) {
			footerBG.style.opacity = (raf_latestKnownScrollY - footerBGtop + windowHeight ) / windowHeight;	
		}
		
	}
	
	// Scrolling 
	$(window).on('scroll', function (event) {
		
		raf_latestKnownScrollY = window.scrollY;
		if(!raf_ticking) {
		  requestAnimationFrame(raf_update);
		}
		raf_ticking = true;
	
	} );
	
	// CUSTOM CURSOR
	if ( !isMobile ) {
		window.cursor = document.getElementById('cursor');
		
		// move cursor as mouse move
		document.addEventListener("mousemove", (e) => {
		   window.cursor.style.left = e.x + 'px'
		   window.cursor.style.top = e.y + 'px'
		});

		// show window.cursor on nav div
		$('.hasCursorNav').hover(
			function() {
				window.cursor.classList.add('visible');
				if ( this.classList.contains('slickSlider') ) window.cursor.classList.add('slick');
			},
			function() {
				window.cursor.classList.remove('visible', 'slick');
			}
		);
				
		// slickSlider
		$('.slickSlider.hasCursorNav .slick-arrow').hover(
			function() {
				if ( this.classList.contains('slick-next') ) window.cursor.classList.add('next');
				else if ( this.classList.contains('slick-prev') ) window.cursor.classList.add('prev');
			},
			function() { window.cursor.classList.remove('next','prev'); }
		);
				
		// TEAM MEMBER PAGE
		$('section.team').find('.photo,.titles').hover(
			function() {
				if ( this.parentNode.classList.contains('open') ) window.cursor.classList.add('visible','less');
				else { 
					window.cursor.classList.add('visible','more');
					window.cursor.classList.remove('less');
				}
			},
			function() { window.cursor.classList.remove('visible','less','more'); }
		);
				
		// PRESS PAGE
		$('section.press').find('.photo,.titles').hover(
			function() {
				window.cursor.classList.add('visible','more');
			},
			function() { window.cursor.classList.remove('visible','more'); }
		);
				
		// BLOG SECTION
		$('section.blog .post a').hover(
			function() {
				window.cursor.classList.add('visible','readmore');
			},
			function() { window.cursor.classList.remove('visible','readmore'); }
		);
		
		// venue-MEGA-slider-nav CURSOR
		if ( !
			$('.venue-mega-slider-nav .slide a').hover(
				function() { //slick-current
					if ( this.parentNode.classList.contains('swiper-slide-active') ) window.cursor.classList.add('visible','more-info');
				},
				function() { window.cursor.classList.remove('visible','more-info'); }
			).length
		) {
			
			megaSlider.hover(
				function() { //slick-current
					var slide = megaSlides.filter('.active').find('.slick-current');
					if ( slide.hasClass('canplay') || ! slide.hasClass('video') ) {
						window.cursor.classList.add('visible','more-info');
					}
				},
				function() {
					window.cursor.classList.remove('visible','more-info');
				}
			);
			
		}
		
		
		// catch cursor hovering on PAGE LOAD 
		$(document).one('mousemove',function(){
			if ( $('.hasCursorNav:hover').length ) {
				window.cursor.classList.add('visible');
								
			}
		});
		
	}
	
/*	function sixSquareMapCheck() {
		// Google Maps
		if ( sixMaps.length ) {
			sixMaps.each(function(i, el) {
				el = $(el);
				if ( el.visible('middle') ) { 
					sixSquareMapFeatures( el );
					sixMaps = sixMaps.not(this);
				}
			});
		}
	}
*/
	// Top Bar toggle (mobile menu)
	$('header button.menu-icon').click(function() {
		var menu = $('#top-bar-menu');
		if ( menu.hasClass('expanded') ) {
			menu.removeClass('expanded');
			this.classList.remove('open');
		} else {
			menu.addClass('expanded');
			this.classList.add('open');
		}
	});
	
	// Drop Down Menu add animation class. Foundation JS interferes with custom transitions
	$('#main-nav').on('show.zf.dropdownMenu',function(e,$sub){ // returns submenu element
		$sub[0].classList.add('fadein');
	});
	$('#main-nav').on('hide.zf.dropdownMenu',function(e,$sub){ // Returns parent menu element
		$($sub[0]).find('.is-dropdown-submenu').removeClass('fadein');
	});
	
	// Off Canvas links: close on click. This ensures the menu is hidden when navigating back. Reducing the transition was somehow necessary. It is fixed by onClick code in nav-offcanvas-topbar.php. The callback below doesn't get called.
	$('#off-canvas a').click(function(e){
		if ( $(this).parent().hasClass('is-accordion-submenu-parent') ) return true;
		if ( $(this).attr('target') == "_blank" ) return true;
		if ( $(this).parent().hasClass('noclick') ) return false;
		if ( slickSliderGrabInhibit ) return false;
		
		var t = $(this);
				
		// don't follow link	
		e.preventDefault();
console.log( 'off-canvas a click!    ' );		
		// Close off-canvas
		$('#off-canvas').foundation('close');
		
		// Trigger body pageLoader
		document.body.classList.add('loading','loading-from-offcanvas');
		
		// follow link after off-canvas closes
		$('#off-canvas').on('closed.zf.offCanvas', function () {
			window.location = t.attr('href');
		});		

		return false;

	});
	
	//slick slider LINK INHIBIT on DRAG/GRAB
	$('.slickSlider a').mousedown(function(e){
		slickSliderGrabInhibit = true;
		e.preventDefault();
		slickSliderGrabY = jQuery(this).closest('.slick-track').css('transform');
		return true;
	});
	
	$('.slickSlider a').mouseup(function(e){
		var compare = jQuery(this).closest('.slick-track').css('transform');
		
		if ( compare == slickSliderGrabY ) {
			slickSliderGrabInhibit = false;
		} else {
			setTimeout(function() { slickSliderGrabInhibit = false; }, 100 );
		}
		
		return true;
	});
		
	// Off-Canvas inner: stop propagation of transitionend event causing premature transition on close
	$('.offcanvas-full-screen-inner').on('transitionend',(e)=>e.stopPropagation());

	// Off-Canvas Open [verified]
	$('#off-canvas').on('opened.zf.offCanvas', function (e) {

		if ( !megaPauseState ) {
			offCanvasMegaPauseState = true;
			megaPause();
		}

	});
	
	// Off-Canvas Open Ended [verified]
	$('#off-canvas').on('openedEnd.zf.offCanvas', function (e) {
		
//		sixSquareMapCheck();
		document.activeElement.blur();
		bodyScrollLock(true);
		
	});

	// Off-Canvas Close [verified]
	$('#off-canvas').on('close.zf.offCanvas', function (e) {
		setTimeout(function(){
			bodyScrollLock(false);
		},100);
		if ( offCanvasMegaPauseState ) megaPause('play');
	});
	
	// Off-Canvas Closed [verified]
	$('#off-canvas').on('closed.zf.offCanvas', function (e) {
		bodyScrollLock(false);
		
	});
	
	// Off-Canvas accordion menu OPEN
//	$('#offcanvas-nav').foundation('showAll');
	
	// Touch hover methods
	if ( isMobile ) {
		touchhover.on('touchstart', function(e) {
			var t = $(this);
			
			if ( t.hasClass('hover') ) {
				return true;
			} else {
				t.addClass('hover');
				touchhover.not(this).removeClass('hover');
				e.preventDefault();
				return false;
			}
			
		});
		document.body.addEventListener('touchstart',function(e) {
			touchhover.removeClass('hover');
		});
	}

	// Newport Experience: Packages / Events
	$('section.packages .package, section.events .event').each(function() {
		var t = $(this),
			iHeight = t.find('.image__inner').height(),
			iHeight = ( iHeight ? iHeight : 500 ),
			tt = t.children('.text'),
			tHeight = tt.height();
		
		if ( tHeight > ( iHeight + 20 ) ) {
			tt.css('maxHeight', iHeight + 'px');
			t.addClass('close');
		}
	}).find('.npt-toggle').click(function() {
		var t = $(this).closest('.package,.event'),
			tt = t.children('.text');
		
		if ( t.hasClass('open') ) {
			var iHeight = t.find('.image__inner').height(),
			iHeight = ( iHeight ? iHeight : 500 );
			
			t.removeClass('open');
			tt.css('maxHeight', iHeight + 'px');
		} else {
			t.addClass('open');
			tt.css('maxHeight', tt[0].scrollHeight + 'px');
		}
	});

	// Lax Scroll Events '.wp-block-media-text','.packages .package','.events .event','.xrooms .room'
	// Took over for scrollAnimates
	// DISABLED 3/21/2024
	var laxBlocks =// $('.wp-block-media-text, .packages .package, .events .event, .rooms .room'),
		laxEvens =// laxBlocks.filter('.even,.wp-block-media-text:not(.has-media-on-the-right)').filter(':not(.no-img-anim)').find('.image,.wp-block-media-text__media').toArray(),
		laxOdds =// laxBlocks.filter(':not(.even):not(.wp-block-media-text),.has-media-on-the-right').filter(':not(.no-img-anim)').find('.image,.wp-block-media-text__media').toArray(),
		laxTexts = [];// laxBlocks.find('.text,.wp-block-media-text__content').add('.footer-bg').toArray();
	if ( laxEvens.length || laxOdds.length || laxTexts.length ) {
		lax.init()
		lax.addDriver('scrollY', function () {
		  return window.scrollY
		}, { inertiaEnabled: false });
		if ( laxOdds.length ) lax.addElements('odds', 
			{
			  scrollY: {
				translateX: [
				  ["elInY", "elCenterY-20"],
				  ['elWidth', 0],
				  { inertia: 1 }
				],
				translateY: [
				  ["elInY", "elCenterY-20"],
				  ['elHeight', 0],
				  { inertia: 1 }
				]
			  }
			},
			{
				domElements: laxOdds,
				onUpdate: function (driverValues, domElement) {
					if ( domElement.style.transform.substr(12,3) == '0px' ) {
						lax.removeElement( domElement );
					}
					return true;
				}
			}
		);
		if ( laxEvens.length ) lax.addElements('evens',
			{
			  scrollY: {
				translateX: [
				  ["elInY", "elCenterY-20"],
				  ['0-elWidth', 0],
				  { inertia: 1 }
				],
				translateY: [
				  ["elInY", "elCenterY-20"],
				  ['elHeight', 0],
				  { inertia: 1 }
				]
			  }
			},
			{
				domElements: laxEvens,
				onUpdate: function (driverValues, domElement) {
					if ( domElement.style.transform.substr(12,3) == '0px' ) {
						lax.removeElement( domElement );
					}
					return true;
				}
			}
		);
		if ( laxTexts.length ) lax.addElements('text', 
			{
			  scrollY: {
				opacity: [
				  ["elInY", "elCenterY-20"],
				  [0, 1]
				]
			  }
			},
				{
					domElements: laxTexts,
					onUpdate: function (driverValues, domElement) {
						if ( domElement.style.opacity > 0.99 ) {
							lax.removeElement( domElement );
						}
						return true;
					}
			}
		);
	}
	
	// Newport Experience: Team Member page
	$('section.team .member').find('.photo,.titles,.npt-toggle').click(function() {
		var member = $(this).parent(),
		cell = member.parent(),
		td = member.find('.details');
		
		if ( member.hasClass('open') ) { // close
			
			cell.removeClass('hasOpen');
			member.removeClass('open');
			
			td.css('maxHeight', '');

		} else { // open
			
			$('section.team .member.open').not(member).removeClass('open').find('.details').css('maxHeight',0);
			$('section.team .member.open').not(member).parent().not(cell).removeClass('hasOpen');
			
			cell.addClass('hasOpen');
			member.addClass('open');
			
			td.css('maxHeight', td[0].scrollHeight + 'px');

		}
		
		if ( !isMobile ) member.children('.photo').trigger('mouseenter');
	});
	
	// Newport Experience: Press page
	$('section.press .item .npt-toggle').click(function() {
		var member = $(this).parent(),
		cell = member.parent(),
		td = member.find('.details');
		
		if ( member.hasClass('open') ) { // close
			
			cell.removeClass('hasOpen');
			member.removeClass('open');
			
			td.css('maxHeight', '');

		} else { // open
			
			$('section.team .member.open').not(member).removeClass('open').find('.details').css('maxHeight',0);
			$('section.team .member.open').not(member).parent().not(cell).removeClass('hasOpen');
			
			cell.addClass('hasOpen');
			member.addClass('open');
			
			td.css('maxHeight', td[0].scrollHeight + 'px');

		}
	});
	
	// Blog Section on non-blog page Read More button
	$('section.blog .read_more a').click(function() {
		
		var t = $(this),
			section = t.closest('section.blog'),
			lastOdd = section.find('.odds .post:visible').eq(-1),
			lastEven = section.find('.evens .post:visible').eq(-1),
			newEvens = 3,
			newOdds = 6;
			
			if ( lastEven.length && lastOdd.length ) {
				var lastEvenTop = lastEven.offset().top,
					lastOddTop = lastOdd.offset().top,
					diff = lastEvenTop - lastOddTop;
				if ( diff > 100 ) newEvens = 2;
				else if ( lastEvenTop && diff < -100 ) newOdds = 4;
			}
			var total = newEvens + newOdds;
			
			posts = section.find('.evens .post.hide').slice(0,newEvens),
			posts = posts.add( section.find('.odds .post.hide').slice(0,newOdds) );
			
		posts.css('opacity',0).removeClass('hide');
		
		if (posts.length < total) t.hide();
		setTimeout( function() {
			posts.css('opacity','');
		}, 100)
	});
	
	// Parallax scrolling for team and blog pages
	if ( Foundation.MediaQuery.atLeast('xsmall') && ( $('section.team').length || $('section.blog').length || $('section.press').length ) ) { 
		$speed = 1.5;
		if ( $('section.blog').length ) {
			if ( $('body').hasClass('page-template-template-blog') ) $speed = 3;
			else $speed = 0.2;
		}
		var teamE = new Rellax('.odds', {'speed':$speed});
		var teamO = new Rellax('.evens', {'speed':-$speed});
	}
	
	// Newport Experience: venue page
	$('.footer-gallery .footerSlider .slick-track').click(function(e) {
		//FUll size gallery blow up
		var macy,
			fsg = $('.fullScreenGallery'),
			fsw = fsg.children('.fullScreenWrapper'),
			activeSlick = $(this).find('.slick-current img'),
//			activeSlickClone = activeSlick.clone(),
			activeSlickCloneGL = activeSlick.clone(),
			active = fsg.find('.id' + activeSlick.data('iid') ).addClass('active'); // set image active in slickslider as active in fsg

//		fsg.scrollLeft(0).scrollTop(0);

/*		// set origin for FSG scale up as click
		if ( e && e.originalEvent && e.originalEvent.clientX && e.originalEvent.clientY ) {
			fsg.css('transformOrigin',e.originalEvent.clientX + 'px ' + e.originalEvent.clientY + 'px' );
		}
*/			
		window.active = active;
		window.activeSlick = activeSlick;
		
		if ( window.activeSlickClicked ) activeSlick.addClass('click');
		else {
			
			activeSlick.addClass('click clickfirst');
			window.activeSlickClicked = true;
		}
		
		
		// SETUP active slick CLONE
		var asPos = activeSlick.offset(),
			asWidth = activeSlick.width();

		window.activeSlickCloneGL = activeSlickCloneGL
			.appendTo('.fsgActiveAnimGL .plane').closest('.fsgActiveAnimGL')
			.css({
				top: ( asPos.top - window.scrollY ) + 'px',
				left: '200%',
				width: (asWidth*2) + 'px',
			})
			.show(function() {
				setTimeout(function(){
					init_webgl();
				},100);
			})
			.on('webGLready', function() {
				$('.fsgActiveAnimGL')
				.css({
					left: asPos.left + 'px',
					width: asWidth + 'px',
					display: 'none'
				})
				.one("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", function(e){

	//				activeSlickCloneGL.off(e);
					if ( window.macy_init_end ) return;
					window.macy_init_end = true;
	console.log('slick clone  GLONEEEEEEEE    ');	
					$('.fullScreenGallery').addClass('open');
					bodyScrollLock(true);
					
					$(this).fadeOut(500,function() {
						window.webGLCurtain.removePlane(window.plane);
						window.activeSlick.css('opacity','').removeClass('click clickfirst');
						$(this).removeClass('ready').find('img').remove();
						window.macy_init_end = false;
						
					});
				})
				.fadeIn(25,function() {
					window.activeSlick.css('opacity',0);
					this.classList.add('ready');
					window.plane.uniforms.mousePosition.value = [0,0];
					window.plane.uniforms.mouseStrength.value = 0.7;
				});
				
				// OPEN gallery
				 $('.fullScreenGallery').show(function(){
				 	this.classList.add('fadeIn');
					window.active.one("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", function(e){
						active.off(e);
						if ( window.macy_init ) return;
						window.macy_init = true;
						
						window.active.attr('data-macy-complete',1);
		console.log('macy init');			
						var fsg = $('.fullScreenGallery'),
							aPos = window.active.offset(),
							aWidth = window.active.width(),
							scrollTop = fsg.scrollTop() + (aPos.top - window.pageYOffset) - ((window.innerHeight - window.active.height())/2),
							scrollLeft = fsg.scrollLeft() + ( aPos.left - window.pageXOffset ) - ((window.innerWidth - aWidth)/2);
		
						fsg.scrollTop(scrollTop).scrollLeft(scrollLeft);
		
						var aPos = window.active.offset();
						
						fsg.addClass('opening');
						
						window.activeSlickCloneGL
							.css({
								top: ( aPos.top - window.scrollY ) + 'px',
								left: aPos.left + 'px',
								width: aWidth + 'px',
							});
					});
					window.macy_init = false;
					window.macy_init_end = false;
					// init Macy or trigger same event
					if ( !window.fsg_macy ) {
						window.fsg_macy = Macy({
							container: '.fullScreenWrapper',
							margin: 38,
							columns: 4,
							breakAt: {
								1024: {
									margin: 36,
									columns: 3
								},
								480: {
									margin: 34,
									columns: 2
								}
							}
						});
						setTimeout(function(){ fsg_macy.reInit(); }, 100);
					}
					else window.active.attr('data-macy-complete',0);
				 
				 });

			});
			
/*		activeSlickClone
			.css({
				top: ( asPos.top - window.scrollY ) + 'px',
				left: asPos.left + 'px',
				width: activeSlick.width() + 'px',
			})
			.addClass('fsgActiveAnim')
			.one("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", function(e){
console.log('slick clone ONEEEEEEEEEEEEEE');
					$(this).off(e);
					fsg.addClass('open');
					this.remove();
				})
			.appendTo('body');
*/

	});
	$('.fsgClose').click(function() {
		if ( $('.fullScreenSlider').hasClass('open') ) {
			
			$('.fullScreenSlider').removeClass('open');
		} else {
			bodyScrollLock(false);
			var fsg = $('.fullScreenGallery');
			fsg.fadeOut(1000).removeClass('opening open fadeIn').find('.active').removeClass('active');
			window.macy_init = false;
			window.macy_init_end = false;
		}

	});
	
	// Full Screen Gallery drag functions
	if ( !isMobile ) $('.fullScreenGallery').on('mousedown', grabMouseDown);
	
	// Click images
	// LINK INHIBIT on DRAG/GRAB
	$('.XXXfullScreenGallery .image').mousedown(function(e){
//		return true;
	});
	
	// Open Slick gallery on image "click"
	$('.fullScreenGallery .image').on('mouseup', function(e){
		if ( isMobile || e.clientX == grab.x || e.clientY == grab.y ) {  console.log('clicked'); console.log(this); console.log(e);
			// Mouse did NOT move; no grab drag
			// init slick slider
			var iid = this.dataset.iid,
				slider = $(this).closest('.fullScreenGallery').next('.fullScreenSlider'),
				slides = slider[0].slick.$slides, 
				slickIndex;
			
			slider.show();
			if ( iid ) {
				for ( let i = 0; i < slides.length; i++ ) {
					if ( slides[i].classList.contains('id'+iid) ) {
						slickIndex = slides[i].dataset.slickIndex;
						break;
					}
				}
				if ( slickIndex > -1 ) slider.slick('slickGoTo', slickIndex, true);
			}
			
			slider.slick('checkResponsive',false,true);
			slider.fadeIn(500,function() {
				slider.addClass('open');
				slider.find('.slick-current').focus();
			});		
			
			
		} else console.log('cancel click'); console.log(e);
		
		return true;
	});
	
	// Link setup for slime in
	$('.wp-block-button__link,.menu-plan-your-event a,button a').each(function() { this.dataset.linkText = this.innerText; })
	
	/* // Load More Posts
	$('.loadMorePosts').each(function(){

		var _t = $(this),
			id = _t.attr('id'),
			winVar = 'loadMorePosts_' + id;
			
		if ( typeof window[winVar] != 'undefined' && window[winVar].current_page && window[winVar].max_page ) {
			$('<span class="button doLoadMorePosts">' + window[winVar].buttonLabel +'</span>')
			.data('lmpID',id)
			.click(function(){nsLoadMorePosts(this);})
			.insertAfter(_t).wrap('<div class="container__loadMoreButton"></div>');
			_t.find('.wp-pagenavi').hide();
		}
		
	});
	
	function nsLoadMorePosts(button){
	//	if ( typeof winVar != 'string' || ! winVar.length ) return;
		
		var button = $(button),
			id = button.data('lmpID'),
			winData = window['loadMorePosts_' + id],
			data = {
				'action': 'sixloadmoreposts',
				'template': winData.template,
				'page' : winData.current_page
			};
 
		$.ajax({ // you can also use $.post here
			url : winData.ajaxurl, // AJAX handler
			data : data,
			type : 'POST',
			beforeSend : function ( xhr ) {
				button.text(winData.buttonLabelLoading + '...'); // change the button text, you can also add a preloader image
			},
			success : function( data ){
				if( data ) { 
					button.text( winData.buttonLabel );
					
			//		$('#' + id).append(data); // insert new posts
					// insert new posts
					var newContent = jQuery(data);
					
					newContent.each(function(){ 
						jQuery(this).hide(); 
					});
					
					newContent.appendTo('#' + id).each(function(i){ 
						jQuery(this).delay(i*250).fadeIn(2500);
					});
					
					winData.current_page++;
 
					if ( winData.current_page == winData.max_page ) button.fadeOut(250); // if last page, remove the button
 
					// $( document.body ).trigger( 'post-load' );
				} else {
					button.remove(); // if no data, remove the button as well
				}
			}
		});
	} */
	

		
}); // document.ready()
$(window).bind("pageshow", function(event) {
	// BODY ANIMATION TRIGGER
	setTimeout(function(){
		document.body.classList.remove('pre-init','loading','loading-from-offcanvas');
		$(window).scroll();
	},200);
});
window.addEventListener('load', function() {
	
	// BODY ANIMATION TRIGGER
	setTimeout(function(){
		document.body.classList.remove('pre-init','loading','loading-from-offcanvas');
		$(window).scroll();
	},200);	
	
	if ( megaSlider.length && megaSlides ) { megaSlides.filter('.active')[0].dispatchEvent(eMega2); }

});

// Breakpoint Change
$(window).on('changed.zf.mediaquery ready', function(event, newSize, oldSize) {
	if ( typeof newSize == 'undefined' ) newSize = Foundation.MediaQuery.current;

	if ( newSize == 'small' ) {
		
	} else if ( oldSize == 'small' ) {

	} 
	if ( newSize && oldSize ) { // actual change, not first call (ready)
		
		miniVenueSwiper();
		
		// Easy Grid Slider reset
		$('.gridSlider').each( function() {
			var gS = $(this);
			var cur = gS.data('gridSliderPos');
			gS.removeClass('gs-' + cur).data('gridSliderPos',0);
		});
		
	}
});


// Gravity Forms: FORM POST RENDER (This includes initial form load, going to the next/previous page on multi-page forms, form rendered with validation errors, confirmation message displayed, etc.)
$(document).bind('gform_post_render', function(event,formID){
	
	// Button Style clicks and check
	jQuery('#gform_wrapper_' + formID + ' .gf_button_style .ginput_container .gfield_radio .gchoice').click(function(){
		var t = jQuery(this),
			i = t.children('input'),
			val = i.val(),
			all = t.siblings('.gchoice');
	
		all.removeClass('checked').children('input').attr('checked',false);
		i.attr('checked',true).change();
		t.addClass('checked');
	
	}).each( function() {
	
		if ( jQuery(this).children('input').is(':checked') ) {
			jQuery(this).addClass('checked');
		}
	
	});
	
	/* Stay In Touch Gravity Form */
	if ( formID == 1 ) {
		
		$('#gform_1 #input_1_1').on('focus',function(){
			$('#gform_1').addClass('focused').removeClass('focuslock');
		}).on('blur',function(e){
			setTimeout( function() {
				if ( !$('#gform_1').hasClass('focuslock') && !$('#gform_1 #input_1_1').val().length ) {
					$('#gform_1').removeClass('focused');
				}
			}, 1000);
		});
		$('#gform_1 #field_1_3').on('click',function() {
			$('#gform_1').addClass('focuslock');
		}).find('input[value="General"],input[value="All"]').on('change',function() {
			var t = this;
			if ( t.checked ) {
				$('#gform_1 #field_1_3').find('input[type="checkbox"]').not(t).prop('checked',true).prop('disabled',true);
			} else {
				$('#gform_1 #field_1_3').find('input[type="checkbox"]').not(t).prop('checked',false).prop('disabled',false);
			}
		});
		if ( $('#gform_1 #input_1_1').val().length ) {
			$('#gform_1 #input_1_1').trigger('focus');
		}
		if ( $('#gform_1 #field_1_3').find('input[value="General"],input[value="All"]').prop('checked') ) {
				$('#gform_1 #field_1_3').find('input[value="General"],input[value="All"]').trigger('change');
		}
	}
	
	
});
		
// fn: Visible
$.fn.visible = function(type) {
	var t            = $(this);
	if ( typeof t.offset() != "object" ) { console.log('visible: not object.'); console.log(this); return false; }
	var	$w            = $(window),
		viewTop       = $w.scrollTop(),
		viewBottom    = viewTop + $w.height(),
		_height		  = t.height(),
		offset        = t.offset(),
		_top          = offset.top,
		_middle		  = _top + (_height/2),
		_bottom       = _top + _height,
		_10			  = _height*0.1;
		
		if ( offset.left <= (0 - t.width()) || offset.left > $w.width() ) return false;
		
		switch (type) {
			case 'top': return (_top +_10 >= viewTop) && (_top < viewBottom);
			case 'middle': return (_middle >= viewTop) && (viewBottom >= _middle);
			//case 'full':
			default: return (_bottom <= viewBottom) && (_top >= viewTop);
		}
};

// Body Scroll Lock
var scrollPosition = 0;

// this has a big bug on ios beacuse of the status bar. The space is taken up by a white box that is not usable.
function bodyScrollLock(lock) { if ( isMobile ) return;
	if ( lock ) {

		scrollPosition = window.pageYOffset;
		document.body.classList.add('locked');
		document.body.style.overflow = 'hidden';
		document.body.style.position = 'fixed';
		document.body.style.top = `-${scrollPosition}px`;
		document.body.style.width = '100%';
		
	} else {
		
		document.body.style.removeProperty('overflow');
		document.body.style.removeProperty('position');
		document.body.style.removeProperty('top');
		document.body.style.removeProperty('width');
		window.scrollTo(0, scrollPosition);
		document.body.classList.remove('locked');

	}
}

// grab
// Example useage: if ( !isMobile ) timelineContainer.on('mousedown', grabMouseDown);
var grab = { top: 0,
			left: 0,
			x: 0,
			y: 0,
			snapUnset: ((typeof InstallTrigger !== 'undefined') || (!!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime))), // Unset scrollsnap for Firefox and Chrome
			el: null
		},
grabMouseDown = function(e) {
	var t = jQuery(this);
    grab = {
        // The current scroll 
        left: this.scrollLeft,
        top: this.scrollTop,
        // Get the current mouse grabition
        x: e.clientX,
        y: e.clientY,
        snapUnset: grab.snapUnset,
        el: this
    };
    
    // Change the cursor and prevent user from sgrab.elcting the text
    grab.el.style.cursor = 'grabbing';
	grab.el.style.userSelect = 'none';
	if ( grab.snapUnset ) grab.el.style.scrollSnapType = 'unset';

    document.addEventListener('mousemove', grabMouseMove);
    document.addEventListener('mouseup', grabMouseUp);
},
grabMouseMove = function(e) {
    // How far the mouse has been moved
    const dx = e.clientX - grab.x;
    const dy = e.clientY - grab.y;

    // Scroll the grab.elment
    grab.el.scrollTop = grab.top - dy;
    grab.el.scrollLeft = grab.left - dx;
},
grabMouseUp = function() {
    grab.el.style.removeProperty('cursor');
    grab.el.style.removeProperty('user-select');
    if ( grab.snapUnset ) grab.el.style.removeProperty('scroll-snap-type');
    
    document.removeEventListener('mousemove', grabMouseMove);
    document.removeEventListener('mouseup', grabMouseUp);
};

// Google Maps Callback fn
window.sixSquareMapInit = function () {
	// Create a new StyledMapType object, passing it an array of styles,
	// and the name to be displayed on the map type control.
	var styledMapType = new google.maps.StyledMapType([
	  {
		"elementType": "geometry",
		"stylers": [{
			"color": "#f5f5f5"
		  }]
	  },
	  {
		"elementType": "labels.icon",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#616161"
		  }]
	  },
	  {
		"elementType": "labels.text.stroke",
		"stylers": [{
			"color": "#f5f5f5"
		  }]
	  },
	  {
		"featureType": "administrative.land_parcel",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#bdbdbd"
		  }]
	  },
	  {
		"featureType": "poi",
		"elementType": "geometry",
		"stylers": [{
			"color": "#eeeeee"
		  }]
	  },
	  {
		"featureType": "poi",
		"elementType": "labels.text",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"featureType": "poi",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#757575"
		  }]
	  },
	  {
		"featureType": "poi.business",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"featureType": "poi.business",
		"elementType": "labels.text",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"featureType": "poi.park",
		"elementType": "geometry",
		"stylers": [{
			"color": "#e5e5e5"
		  }]
	  },
	  {
		"featureType": "poi.park",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#9e9e9e"
		  }]
	  },
	  {
		"featureType": "road",
		"elementType": "geometry",
		"stylers": [{
			"color": "#ffffff"
		  }]
	  },
	  {
		"featureType": "road",
		"elementType": "labels.icon",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"featureType": "road.arterial",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#757575"
		  }]
	  },
	  {
		"featureType": "road.highway",
		"elementType": "geometry",
		"stylers": [{
			"color": "#dadada"
		  }]
	  },
	  {
		"featureType": "road.highway",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#616161"
		  }]
	  },
	  {
		"featureType": "road.local",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#9e9e9e"
		  }]
	  },
	  {
		"featureType": "transit",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"featureType": "transit.line",
		"elementType": "geometry",
		"stylers": [{
			"color": "#e5e5e5"
		  }]
	  },
	  {
		"featureType": "transit.station",
		"elementType": "geometry",
		"stylers": [{
			"color": "#eeeeee"
		  }]
	  },
	  {
		"featureType": "water",
		"elementType": "geometry",
		"stylers": [{
			"color": "#B4D6DD"
		  }]
	  },
	  {
		"featureType": "water",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#9e9e9e"
		  }]
	  }
	], {name: 'Styled Map'});
	
	sixMaps.each(function() {
	
		var googleMap = new google.maps.Map( this, {
			zoom: 13,
			center: new google.maps.LatLng( sixScript.gmap_lat, sixScript.gmap_long ),
			mapTypeId: 'roadmap',
			mapTypeControl: false,
			fullscreenControl: false,
			streetViewControl: false,
			scrollwheel: false,
			"featureType": "poi.business",
			"stylers": [
				{
					"visibility": "off"
				}
			]		
		});

		//Associate the styled map with the MapTypeId and set it to display.
		googleMap.mapTypes.set('styled_map', styledMapType);
		googleMap.setMapTypeId('styled_map');
		
		$(this).data('gmap', googleMap);
	
	});

}
// Google Maps Feature / pin / display fn
function sixSquareMapFeatures( map ) {

	if ( typeof map != 'object' || typeof google != 'object' ) return false;
	
	var googleMap = map.data('gmap');

	if ( typeof map.data('gmapMarkers') == 'undefined' ) {
		// First init!
		var features = [
			{
				position: new google.maps.LatLng( sixScript.gmap_lat, sixScript.gmap_long ),
				type: 'info',
				title: sixScript.blogname ,
				animation: google.maps.Animation.DROP
			}
		];
		var icon = {
			url: sixScript.gmap_icon,
			scaledSize: new google.maps.Size(45,61),
//			origin: new google.maps.Point(0,0),
			anchor: new google.maps.Point(22,60)
		};
		// Create markers.
		map.data('gmapMarkers',[]);

		features.forEach(function(feature) {
		  var marker = new google.maps.Marker({
			position: feature.position,
			map: googleMap,
			icon: icon,
			animation: feature.animation,
			title: feature.title,
			clickable: true
		  }).addListener('click', function(e) {
					var pid = sixScript.gmap_placeid,
						destination = ( pid && pid.length? pid : sixScript.gmap_lat + ',' + sixScript.gmap_long),// sixScript.blogname ),
						url = "https://www.google.com/maps/dir/?api=1&destination=" + destination + "&destination_place_id=" + pid;
						window.open(url);
			});
		  map.data('gmapMarkers').push(marker);
		});

	} else {

		// reinit
		googleMap.setCenter( new google.maps.LatLng( sixScript.gmap_lat, sixScript.gmap_long ) );
		map.data('gmapMarkers')[0].setAnimation( google.maps.Animation.DROP );
		
	}
	
}

// jQuery Easings
$.extend( $.easing, {
	easeOutCubic: function (x, t, b, c, d) {
			return c*((t=t/d-1)*t*t + 1) + b;
		},
	easeInQuad: function (x, t, b, c, d) {
	    return c*(t/=d)*t + b;
	},
});


})(jQuery);